module.exports = __webpack_public_path__ + "989fcb374c0b3b2529d3dbe2ccdacbaf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shared/circle-red.png
// module id = 34
// module chunks = 0